/* @flow */
import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { Card, CardTitle, CardText } from 'material-ui/Card';

import JobRequestHeader from './components/JobRequestHeader';
import JobRequestOffers from './components/JobRequestOffers';

import type { JobRequest_request } from './__generated__/JobRequest_request.graphql';

import { adminAcceptJobOfferMutation } from '../../mutations';
import enhancer from '../enhancer';

const styles = {
  header: {
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  container: {
    width: '100%',
  },
  card: {
    padding: 20,
  },
};

type Props = {
  request: JobRequest_request,
};

class JobRequest extends Component<Props> {
  handleForceAccept = async jobOfferId => {
    try {
      await adminAcceptJobOfferMutation({
        input: { jobOfferId },
      });
      // eslint-disable-next-line no-alert
      alert('Success');
    } catch (ex) {
      // eslint-disable-next-line no-alert
      alert(ex.message);
    }
  };

  render() {
    const { request } = this.props;

    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <Card>
            <CardTitle
              title="Job Info"
              // $FlowFixMe
              subtitle={request.student.fullname}
              actAsExpander
            />
            <CardText>
              <JobRequestHeader request={request} />
            </CardText>
          </Card>
        </div>

        <div style={styles.card}>
          <Card>
            <CardTitle title="Offers" />
            <CardText>
              <JobRequestOffers
                request={request}
                handleForceAccept={this.handleForceAccept}
              />
            </CardText>
          </Card>
        </div>
      </div>
    );
  }
}

const query = graphql`
  query JobRequestAdminQuery($nodeId: ID!, $jobOfferStatus: JobOfferStatus) {
    request: node(id: $nodeId) {
      ...JobRequest_request
    }
  }
`;

export default enhancer(JobRequest, {
  relay: {
    query,
    create: () =>
      createFragmentContainer(JobRequest, {
        request: graphql`
          fragment JobRequest_request on JobRequest {
            id
            ...JobRequestHeader_request
            student {
              fullname
            }
            ...JobRequestOffers_request
          }
        `,
      }),
  },
});



// WEBPACK FOOTER //
// ./src/modules/job/JobRequest.js